import { RacingTracks } from "@/constants/tracks/RacingTracks";

import { MetaInfoTypes } from "../brandVariables.types";

export const elgigantenMeta: MetaInfoTypes = {
  trackName: "Monza Grand Prix - Italy",
  playerTeamOrCarKey: "",
  playerTeamOrCarValue: "",
  team: "",
  map: RacingTracks["elgiganten-nbxpa"],
  1: {
    key: "Turns:",
    value: "11",
  },
  2: {
    key: "Length:",
    value: "5.793 km",
  },
  3: {
    key: "Difficulty:",
    value: "very easy",
  },
  4: {
    key: "Record:",
    value: "1:21.046",
  },
};
